export default __webpack_public_path__ + "static/media/Cellmedia_White.4d538c5c.svg";